export const ALIGNMENT_TYPE_BOTTOM = 'bottom';
export const ALIGNMENT_TYPE_CENTER = 'center';
export const ALIGNMENT_TYPE_LEFT = 'left';
export const ALIGNMENT_TYPE_MIDDLE = 'middle';
export const ALIGNMENT_TYPE_RIGHT = 'right';
export const ALIGNMENT_TYPE_TOP = 'top';
